import { render, staticRenderFns } from "./Crisis_reporting.vue?vue&type=template&id=6c489e64"
import script from "./Crisis_reporting.vue?vue&type=script&lang=js"
export * from "./Crisis_reporting.vue?vue&type=script&lang=js"
import style0 from "./Crisis_reporting.vue?vue&type=style&index=0&id=6c489e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports